import { Outlet } from "react-router-dom";

import Box from "@mui/material/Box";

import DataHubPageTitle from "../data-hub/components/DataHubPageTitle";

const TelemetryPage = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: ".5em",
      }}
    >
      <DataHubPageTitle />
      <Outlet />
    </Box>
  );
};

export default TelemetryPage;
